import { CHECKOUT_AU, CHECKOUT_GB, CHECKOUT_NZ, CHECKOUT_US, type CheckoutCountry } from '@/lib/checkout/types'

import { PriceProductType } from '@/clients/payment-service'

// Preorder

// const PREORDER_PLANS_PAGE = `/plans/choose-plan-58421`

// const BRANCH_A_VARIANT = '11354' // default buy now

// Constants used to determine which product config to use
export const GB_DEFAULT_PREORDER_PLANS_PAGE = '/choose-plan-58421'

export const QUIZ_COMPLETE_COOKIE_NAME = 'cQuizComplete'

export const QUIZ_ID_COOKIE_NAME = 'cUserId'

// Shipping
export const DELIVERY_ESTIMATES: Record<CheckoutCountry, string> = {
  [CHECKOUT_GB]: '3–7 working days',
  [CHECKOUT_US]: '7–10 business days',
  [CHECKOUT_AU]: '8–15 working days',
  // TODO(ops): confirm the NZ delivery estimate before launch
  [CHECKOUT_NZ]: '8–15 working days',
}

// Zoe Plus test kit shipping expectations
export const TEST_KIT_SHIPPING_EXPECTATIONS_GB = 'be shipped within 3-5 working days'
export const TEST_KIT_SHIPPING_EXPECTATIONS_US = 'be shipped within 3-5 working days'

// Zoe Plus route
export const ZOE_PLUS_ROUTE = process.env.NEXT_PUBLIC_ZOE_PLUS_ROUTE || 'buymembership'

// PDP is /[locale]/buyguthealthbar; checkout subflow is /[locale]/buyguthealthbar/{email,signup,checkout,...}.
export const GUT_HEALTH_BARS_ROUTE = 'buyguthealthbar'

// PDP is /[locale]/daily30; checkout subflow is /[locale]/daily30/{email,signup,checkout,...}.
export const DAILY30_ROUTE = 'daily30'

// Geo countries the unlocalised /daily30 will sell to; anything else gets the waitlist.
export const DAILY30_CHECKOUT_COUNTRY_ALLOW_LIST: string[] = [CHECKOUT_GB, CHECKOUT_US, CHECKOUT_AU]

export const SHIPPING_TIMES: ReadonlyArray<{
  type: PriceProductType
  times: Partial<Record<CheckoutCountry, string>>
}> = [
  {
    type: PriceProductType.GUT_MICROBIOME_TEST,
    times: { [CHECKOUT_US]: TEST_KIT_SHIPPING_EXPECTATIONS_US, [CHECKOUT_GB]: TEST_KIT_SHIPPING_EXPECTATIONS_GB },
  },
  {
    type: PriceProductType.BARS,
    times: {
      [CHECKOUT_GB]: `arrive in ${DELIVERY_ESTIMATES[CHECKOUT_GB]}`,
      [CHECKOUT_US]: `arrive in ${DELIVERY_ESTIMATES[CHECKOUT_US]}`,
      [CHECKOUT_AU]: `arrive in ${DELIVERY_ESTIMATES[CHECKOUT_AU]}`,
      [CHECKOUT_NZ]: `arrive in ${DELIVERY_ESTIMATES[CHECKOUT_NZ]}`,
    },
  },
  {
    type: PriceProductType.DAILY30,
    times: {
      [CHECKOUT_US]: `arrive in ${DELIVERY_ESTIMATES[CHECKOUT_US]}`,
      [CHECKOUT_GB]: `arrive in ${DELIVERY_ESTIMATES[CHECKOUT_GB]}`,
      [CHECKOUT_AU]: `arrive in ${DELIVERY_ESTIMATES[CHECKOUT_AU]}`,
      [CHECKOUT_NZ]: `arrive in ${DELIVERY_ESTIMATES[CHECKOUT_NZ]}`,
    },
  },
]
